import { idMessages } from "./id";

export type Locale = "en" | "id";

export const DEFAULT_LOCALE: Locale = "en";
export const SUPPORTED_LOCALES: { code: Locale; label: string; short: string }[] = [
  { code: "en", label: "English", short: "EN" },
  { code: "id", label: "Bahasa Indonesia", short: "ID" },
];
export const LOCALE_STORAGE_KEY = "aibas_locale";
export const LOCALE_COOKIE = "aibas_locale";

const dictionaries: Record<Locale, Record<string, string>> = {
  en: {},
  id: idMessages,
};

export function isLocale(value: unknown): value is Locale {
  return value === "en" || value === "id";
}

// Module-level current locale so plain functions and module-level constants can
// call t() without a hook. LocaleBoundary remounts its subtree when the locale
// changes, so every render re-reads it.
let currentLocale: Locale = DEFAULT_LOCALE;

export function getCurrentLocale(): Locale {
  return currentLocale;
}

export function setCurrentLocale(locale: Locale): void {
  currentLocale = locale;
}

export type TranslateParams = Record<string, string | number | null | undefined>;

/**
 * Translate an English source string. English is the default and the key, so an
 * untranslated string simply renders in English. Use {name} placeholders.
 */
export function t(text: string, params?: TranslateParams): string;
export function t<T>(text: T, params?: TranslateParams): T;
export function t(text: unknown, params?: TranslateParams): unknown {
  if (typeof text !== "string") return text;
  const translated = dictionaries[currentLocale][text] ?? text;
  if (!params) return translated;
  return translated.replace(/\{(\w+)\}/g, (match, key: string) =>
    params[key] === undefined || params[key] === null ? match : String(params[key])
  );
}

const LEGACY_STATUS_EN: Record<string, string> = {
  Diajukan: "Submitted",
  "Diajukan Finish": "Finish Submitted",
  Disetujui: "Approved",
  Aktif: "Active",
  Diperpanjang: "Extended",
  Selesai: "Completed",
  Ditolak: "Rejected",
  Menunggu: "Pending",
  Dieskalasi: "Escalated",
  Draf: "Draft",
};

/** Display label for a stored status that may still use the legacy Indonesian value. */
export function statusLabel(status: string | null | undefined): string {
  if (!status) return "";
  return t(LEGACY_STATUS_EN[status] ?? status);
}
